<h3-tool-mode
  [buttons]="buttons"
  [tool]="tool"
  eventBucket="annotation"
  [(ngModel)]="tool.mode"
></h3-tool-mode>

<ng-template #clickxIcon>
  <fa-layers [fixedWidth]="true">
    <fa-icon [icon]="faDrawPolygon"></fa-icon>
    <fa-icon
      class="bolt"
      [icon]="faBolt"
      transform="shrink-2 up-8 right-16"
    ></fa-icon>
  </fa-layers>
</ng-template>
